import * as Configuration from 'src/ajs-app/app.constants.js';

export class PromoCodeService {
  constructor($http) {
    this.$http = $http;
  }

  getPromoCodeOperations(companyId) {
    return this.$http.get(`${Configuration.constants.baseUrl}api/1.0/companies/${companyId}/promo-code/operations`);
  }
  static PromoCodeFactory($http) {
    return new PromoCodeService($http);
  }
}

PromoCodeService.PromoCodeFactory.$inject = ['$http',];
